exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2BzF5{position:relative;padding:24px 90px 24px 24px;border-bottom:1px solid rgba(0,0,0,0.1)}._2BzF5:last-child{border:none}._2B-MR{font-family:\"HelveticaNeue\", \"Helvetica Neue\", \"helvetica\", \"Sans-Serif\";font-size:16px;line-height:1.5;font-weight:normal;font-stretch:normal;font-style:normal;letter-spacing:normal;color:#000000;margin:0;padding:0}._3ywUA{font-family:\"HelveticaNeue\", \"Helvetica Neue\", \"helvetica\", \"Sans-Serif\";font-size:12px;line-height:1.33;color:#000000;font-weight:normal;font-stretch:normal;font-style:normal;letter-spacing:normal;margin:12px 0 0 0;padding:0}._3fZ_I{position:absolute;right:24px;top:24px}@media (max-width: 375px){._2B-MR{font-size:16px;line-height:22px}._3ywUA{margin-top:6px}}\n", ""]);

// Exports
exports.locals = {
	"section": "_2BzF5",
	"section_title": "_2B-MR",
	"sectionTitle": "_2B-MR",
	"section_text": "_3ywUA",
	"sectionText": "_3ywUA",
	"toggle": "_3fZ_I"
};